import React from 'react';
import { SectionFolder } from '@src/components/SectionFolder';
import { SectionTitle } from '@src/components/SectionTitle';
import { SectionProps } from '../types/Settings';
import { LocalizedStrings } from '@src/utils/localizedStrings';
import { SECTION_TITLE_SIZE } from '../utils/variables';
import { SectionContent } from '../subcomponents/SectionContent';
import { SettingsCheckbox } from '../subcomponents/SettingsCheckbox';
import { ShopThisLookIcon } from '../../Icons/DropDownIcons/ShopThisLook';
import { useQuickProducts } from '../hooks/useQuickProducts';
import { style } from 'typestyle';
import { FineTunedOverlay } from '../subcomponents/FineTunedOverlay';

interface QuickProductsProps extends SectionProps {
  currentLayout: string;
  carouselType?: 'uniform' | 'spotlight' | 'buy_box';
  onGoToAdvancedSettings?: () => void;
}

const QuickProducts = ({ opened, onOpen, editedWidget, setEditedWidget, currentLayout, carouselType, onGoToAdvancedSettings }: QuickProductsProps) => {
  // Get the hook instance directly - this component is special and should maintain its own state
  const {
    isExactEnabled,
    isSimilarEnabled,
    isFineTuned,
    toggleExactProducts,
    toggleSimilarProducts,
    resetFineTunedSettings,
  } = useQuickProducts({ 
    editedWidget, 
    setEditedWidget, 
    currentLayout: currentLayout as any,
    carouselType
  });

  // We don't need to provide the context here, as it's already provided by the parent
  // Just use the props directly
  return (
      <SectionFolder
        title={
          <SectionTitle size={SECTION_TITLE_SIZE}>
            <ShopThisLookIcon />
            {lang.title.main}
          </SectionTitle>
        }
        opened={opened}
        onOpen={onOpen}
      >
        <div className={wrapperStyle}>
          <SectionContent>
            {isFineTuned ? (
              <FineTunedOverlay 
                onReset={resetFineTunedSettings}
                onAdvancedSettings={onGoToAdvancedSettings || (() => {})}
              />
            ) : (
              <>
                <SettingsCheckbox
                  label={lang.fields.exact}
                  checked={isExactEnabled}
                  onClick={toggleExactProducts}
                />
                <SettingsCheckbox
                  label={lang.fields.similar}
                  checked={isSimilarEnabled}
                  onClick={toggleSimilarProducts}
                />
              </>
            )}
          </SectionContent>
        </div>
      </SectionFolder>
  );
};

const wrapperStyle = style({
  position: 'relative',
  width: '100%'
});



const lang = LocalizedStrings({
  en: {
    title: {
      main: 'Products',
    },
    fields: { 
      exact: 'Show exact products linked',
      similar: 'Show similar products linked',
    },

  },
});

export default QuickProducts;
